// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBokNnZuABf3LkFRch9axQqqUqCFtd73aM",
    authDomain: "dremotechsolutionswebapp.firebaseapp.com",
    projectId: "dremotechsolutionswebapp",
    storageBucket: "dremotechsolutionswebapp.firebasestorage.app",
    messagingSenderId: "108882716476",
    appId: "1:108882716476:web:d054e47235cd0610c46039"

};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage , auth};